import {useEffect, useState} from 'react';
import {useToastContext} from '../contexts/toast-context';

export const useQuantitySelector: ({
  availableQuantity,
  maxQuantity,
  isCashModal,
  maxQuantityAvailableToPurchase,
  initialPurchaseQty,
  isTraxxStemz,
  isEmilG,
  isJoshSavage,
}: {
  availableQuantity: number;
  maxQuantity: number;
  isCashModal?: boolean;
  maxQuantityAvailableToPurchase: number;
  initialPurchaseQty?: number;
  isTraxxStemz?: boolean;
  isEmilG?: boolean;
  isJoshSavage?: boolean;
}) => {
  onIncrement: () => void;
  onDecrement: () => void;
  onResetQuantity: (qty: number) => void;
  purchaseQuantity: number;
  initialPurchaseQty?: number;
  isTraxxStemz?: boolean;
  isEmilG?: boolean;
  isJoshSavage?: boolean;
} = ({
  availableQuantity,
  maxQuantity,
  isCashModal,
  maxQuantityAvailableToPurchase,
  initialPurchaseQty = 1,
  isTraxxStemz,
  isEmilG,
  isJoshSavage,
}) => {
  const toast = useToastContext();
  const [purchaseQuantity, setPurchaseQuantity] = useState(initialPurchaseQty);
  useEffect(() => {
    setPurchaseQuantity(initialPurchaseQty);
  }, [initialPurchaseQty]);

  const onIncrement = () => {
    if (isTraxxStemz) return;
    // if (isCashModal && purchaseQuantity + 1 > maxQuantityAvailableToPurchase) {
    //   // For cash purchases we have to check the amount available in the
    //   // treasury account. The total value of the order must not exceed the amount available
    //   // in the treasury account.
    //   toast.addInfoToast('Maximum purchase quantity exceeded.');
    // } else
    if (
      purchaseQuantity + 1 <= Number(availableQuantity) &&
      purchaseQuantity + 1 <= maxQuantity
    ) {
      setPurchaseQuantity(purchaseQuantity + 1);
    } else {
      toast.addInfoToast('Maximum purchase quantity exceeded.');
    }
  };

  const onDecrement = () => {
    if (isTraxxStemz) return;
    if (purchaseQuantity > 1) setPurchaseQuantity(purchaseQuantity - 1);
  };

  const onResetQuantity = (qty: number) => {
    setPurchaseQuantity(qty);
  };

  return {onIncrement, onDecrement, onResetQuantity, purchaseQuantity};
};
